<template>
  <div
    class="check-box"
    :class="{ active: isChecked, reverse: isReverse, bgwhite: isBgWhite }"
    @click.stop="handleCheckBoxClick"
  >
    <i class="far fa-check"></i>
  </div>
</template>

<script>
export default {
  name: 'CheckBox',

  props: {
    isChecked: {
      type: Boolean,
      default: false,
    },
    isReverse: {
      type: Boolean,
      default: false,
    },
    isBgWhite: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleCheckBoxClick() {
      this.$emit('handleCheckBoxClick');
    },
  },
};
</script>

<style lang="scss" scoped>
.check-box{
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: $deepColor;
  border: solid 1px $white;
  .fa-check{
    color: $deepColor;
  }
  &.active{
    background: $white;
    color: $deepColor;
    .fa-check{
      color: $deepColor;
    }
  }
  &.bgwhite{
    background: $white!important;
    .fa-check{
      color: $white;
    }
    &.active{
      .fa-check{
        color: $deepColor;
      }
    }
  }
}
.reverse {
  &.active {
    .fa-check {
      color: $white;
    }
  }
}
</style>
